import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { watch, onMounted, ref } from 'vue';
import { csrfApi } from '@/http';
import { useConfigStore, useGlobalStore } from '@/stores';
import { loadAndSetAppLang } from '@/i18n';
import { OrganizationType } from './composables/types';

// stores

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const configStore = useConfigStore();
const globalStore = useGlobalStore();

const organization = ref<OrganizationType | undefined>(undefined);

async function csrf() {
  await csrfApi.get('');
}

onMounted(() => {
  csrf();
  globalStore.fetchOrganization();
  globalStore.fetchContactChannels(undefined);
  globalStore.fetchGovernances(undefined);
  globalStore.fetchTeams(undefined);
  globalStore.fetchSliders(undefined);

  organization.value = globalStore.organization;
  document.title = configStore.stringLang(
    organization.value.nameAr,
    organization.value.nameEn
  );
});

// watch for locale change
loadAndSetAppLang(configStore.locale);
// loadAndSetAppLang('ar');
watch(
  () => configStore.locale,
  async (value: string) => {
    loadAndSetAppLang(value);
  }
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { class: "bg-grey-lighten-3" }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }))
}
}

})